import { observer } from 'mobx-react-lite';
import { WarningCircle } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { useT } from './useT';
import { TOKEN_WarningsStore } from './WarningsStore';
import { TOKEN_SimulationStore } from './SimulationStore';

export const WarningsView = observer(function WarningsView() {
  const warnings = useResolve(TOKEN_WarningsStore);
  const sim = useResolve(TOKEN_SimulationStore);
  const t = useT();
  const q = sim.quarantine;
  if (warnings.warnings.length === 0 && q.length === 0) return null;
  return (
    <section className="border-t-2 border-amber-signal bg-amber-signal/5 px-4 py-2 text-xs dark:bg-amber-signal/10">
      <header className="mb-1 flex items-center justify-between">
        <strong className="flex items-center gap-2 font-mono uppercase tracking-wider text-amber-deep">
          <WarningCircle weight="fill" size={14} />
          {q.length} {t.warnings.quarantined}
        </strong>
        {warnings.warnings.length > 0 && (
          <button
            type="button"
            onClick={warnings.clear}
            className="font-mono text-steel-500 hover:text-steel-700 dark:hover:text-steel-300"
          >
            {t.warnings.clear}
          </button>
        )}
      </header>
      <ul className="max-h-24 space-y-0.5 overflow-y-auto font-mono text-steel-600 dark:text-steel-400">
        {q.slice(0, 50).map((r, i) => (
          <li key={i}>
            <span className="text-steel-400">
              [{r.source}@{r.rowIndex}]
            </span>{' '}
            {r.reason}
          </li>
        ))}
        {q.length > 50 && <li className="text-steel-400">… {q.length - 50} more</li>}
      </ul>
    </section>
  );
});
